module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_innlandet_neg.00d96c36.svg";